import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    AfterViewInit,
} from '@angular/core';
import {BsModalEventsEmitter} from 'src/app/modules/shared/events/bsModal.events';
import {AppLoadingEventsEmitter} from '../../../events/loading.events';
import {Router} from '@angular/router';
import {DailyMealViewModel} from '../../../viewModels/dailyMeal.viewModel';
import {DateService} from '../../../services/date.service';
import {BsModalRef} from 'ngx-bootstrap';
import {TriggerActionEventsEmitter} from '../../../events/triggerAction.events';
import {ProductsService} from '../../../services/products.service';
import {RecipeViewModalModel} from '../../../viewModels/recipe.viewModel';
import {Constants} from '../../../config/constants.config';
import {generateRandomString} from '../../../utilities/string.utilities';

@Component({
    selector: 'app-recipes-text',
    templateUrl: './recipes-text.component.html',
    styleUrls: ['./recipes-text.component.scss']
})
export class RecipesTextComponent implements OnInit, AfterViewInit {
    private readonly mobileWidth: number = 576;

    @ViewChild('wrapper') wrapper: ElementRef<HTMLElement>;

    dateObj: Date;
    diaryRecipes: RecipeViewModalModel[] = [];
    showNotFound = false;

    constructor(
        public readonly bsModalRef: BsModalRef,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly dateService: DateService,
        private readonly productsService: ProductsService,
        readonly constants: Constants,
    ) {
    }

    ngOnInit() {
        const interval = setInterval(() => {
            if (this.dateObj) {
                clearInterval(interval);

                this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

                this.productsService.getRecipesText(this.dateService.getDate(this.dateObj))
                    .subscribe(diaryRecipes => {
                        this.diaryRecipes = diaryRecipes;
                        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

                        this.showNotFound = diaryRecipes.length <= 0;
                    });
            }
        });
    }

    ngAfterViewInit() {
        if (window.innerWidth <= this.mobileWidth) {
            this.toFullscreen();
        } else {
            this.defaultScreen();
        }
    }

    onDateChanged(date: Date) {
        this.dateObj = date;
        this.ngOnInit();
    }

    onDateForwards() {
        this.dateObj = this.dateService.dayForwards(this.dateObj);
        this.onDateChanged(this.dateObj);
    }

    onDateBackwards() {
        this.dateObj = this.dateService.dayBackwards(this.dateObj);
        this.onDateChanged(this.dateObj);
    }

    private toFullscreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modalContent = this.wrapper.nativeElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.display = 'flex';
        modalDialog.style.margin = '0';
        modalDialog.style.padding = '0';
        modalDialog.style.width = '100%';
        modalDialog.style.maxWidth = 'unset';
        modalDialog.style.minHeight = '100%';
        modalDialog.style.height = '100%';
        modalContent.style.borderRadius = '0';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    private defaultScreen() {
        const modalDialog = this.wrapper.nativeElement.parentElement.parentElement.parentElement;
        const modal = this.wrapper.nativeElement.parentElement;

        modalDialog.style.borderRadius = '0';
        modalDialog.style.maxWidth = '564px';
        modal.style.display = 'block';
        modal.style.height = '100%';
    }

    rand() {
        return generateRandomString(25);
    }


    isIOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    }
}
